<template>
  <yd-list theme="4" class="l-list">
    <yd-list-item v-for="(article,key) in articleList" :key="key" class="article" type="link" :href="'/'+params.id+'/content/'+article.id">
      <img slot="img" :src="article.thumbnail_url">
      <span slot="title" class="mumber_name">{{article.title}}</span>
      <yd-list-other slot="other">
        <div class="mumber_info">
          <span class="demo-list-price">{{article.summary}}</span>
        </div>
      </yd-list-other>
    </yd-list-item>
  </yd-list>
</template>

<script type="text/babel">
import axios from 'axios'
export default {
  data () {
    return {
      articleList: [],
      term: [],
      params: this.$route.params
    }
  },
  methods: {
    getContent () {
      let data = {fair_id: this.params.id, termid: this.params.termid}
      axios
        .post('/cat/search-ticket', data)
        .then(this.getContentSucc)
    },
    getContentSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.articleList = res.data
        this.term = res.term
      }
    },
    HistoryBack () {
      window.history.back()
    }
  },
  mounted () {
    this.getContent()
  }
}
</script>

<style lang="stylus" scoped>
  .yd-list
    background:none!important
    padding: 0
  .mumber_name
    display: block
    font-size: .32rem
    color: #333
    font-weight: normal
    margin-top: .2rem

  .yd-list-img img
    margin-top: 0
    min-height: 100%
  .article:nth-child(1)
    margin-top: .2rem
  .article>:last-child>:last-child
    padding: 0
  .article>:first-child
    padding: 0!important
    width: 1.52rem!important
    min-width: 1.52rem!important
    height: 1.52rem!important
    border-radius: 50%
  .article>:last-child
    padding: 0!important
    padding-left: .4rem!important
  .article
    width: calc(100% - .4rem)
    min-height: 2.4rem
    border-radius: .2rem
    margin: 0 auto
    margin-bottom: .12rem
    padding: .4rem .2rem!important
    background-color: rgba(255,255,255,0.9)
    border-bottom: solid 1px #e0e0e0
  .article>:last-child
    background: none
</style>

<style>
.l-list .yd-list-mes {
  width: 50%;
}

.l-list .mumber_name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
}

.l-list .mumber_info {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/template1/SingleGuest.vue